/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { useSelector } from "react-redux";
import { State, AppPermissions } from "../../../../core";

export interface CustomProps {
  isAuthRequired: boolean;
  tabName: string;
  tabChangeHandler: (tabName: string) => void;
}
enum TabNames {
  InvoiceRejectedReason = "Invoice Rejected Reason",
  InvoiceTransactionRejectedReason = "Invoice Transaction Rejected Reason",
}

export interface StateProps {
  isAuthenticationCompleted: boolean;
}

const LeftMenu: React.FunctionComponent<CustomProps> = (props) => {
  const authState = useSelector((state: State) => state.authUser);
  const tabs = Object.keys(TabNames as any);
  const [tabName, setTabName] = React.useState<string>(
    props.tabName || (TabNames as any)[tabs[0]]
  );
  const setElementActive = (tabValue: string) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  React.useEffect(() => {
    /* tslint:disable:no-string-literal */
    // if (authState.apiPermissions?.[AppPermissions.ViewInvoiceReason]) {
    if (authState.apiPermissions?.[AppPermissions.ViewLeadQuality]) {
      (TabNames as any)["InvoiceRejectedReason"] = "Invoice Rejected Reason";
    }

    setTabName((TabNames as any)[Object.keys(TabNames as any)[0]]);
    props.tabChangeHandler((TabNames as any)[Object.keys(TabNames as any)[0]]);
  }, []);

  return (
    <div className="col-xl col-lg-3 col-12 bg-gray-100 border-right px-3 py-4 lead-settings-menu">
      <ul className="list-unstyled mb-0 px-0 font-normal font-weight-semibold position-relative lead-settings-list">
        {tabs?.map((item) => {
          return (
            <li>
              <a
                href="javascript:void(0)"
                className={`px-3 py-2 d-flex align-items-center rounded ${tabName === (TabNames as any)[item] ? "active" : ""
                  }`}
                onClick={(e) => setElementActive((TabNames as any)[item])}
              >
                <span className="py-1 d-block">{(TabNames as any)[item]}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LeftMenu;
